var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .redcircle-cls {\n        fill: #f96869;\n        stroke: none;\n      }\n\n      .cross-red-circle-cls {\n        fill: #fff;\n        stroke: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "redcircle-cls",
    d: "M25.04,2.68C12.71,2.68,2.68,12.71,2.68,25.04s10.03,22.36,22.36,22.36,22.36-10.03,22.36-22.36S37.37,2.68,25.04,2.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cross-red-circle-cls",
    d: "M36.24,32.56c1.02,1.02,1.02,2.66,0,3.68-.51.51-1.17.76-1.84.76s-1.33-.25-1.84-.76l-7.52-7.52-7.52,7.52c-.51.51-1.17.76-1.84.76s-1.33-.25-1.84-.76c-1.02-1.02-1.02-2.66,0-3.68l7.52-7.52-7.52-7.52c-1.02-1.02-1.02-2.66,0-3.68,1.01-1.02,2.66-1.02,3.68,0l7.52,7.52,7.52-7.52c1.01-1.02,2.66-1.02,3.68,0,1.02,1.02,1.02,2.66,0,3.68l-7.52,7.52,7.52,7.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconCircleCross);
export default __webpack_public_path__ + "static/media/cloud_icon_circle_cross.cc7795801ac50c35a7bf234101dc0c40.svg";
export { ForwardRef as ReactComponent };